export default __webpack_public_path__ + "static/media/notification_icon_24m.fc00b56d.png";